<template>
  <div class="thesis-practice-popper-sample-template">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog width="500px"
                    custom-class="thesis-practice-popper-sample-template-dialog"
                    :title="`${curTemplateInfo.name}模板样例`"
                    :visible.sync="visible"
                    @open="initData">
      <div class="sample-template-main">
        <div class="upload-template-wrap">
          <div class="upload-template">
            <FileLinkUploader v-model="templateUrl"
                              :result-key="curTemplateInfo.resultKey"
                              :show-file-list="false"
                              :upload-url="uploader.uploadUrl"
                              :upload-params="uploadParams"
                              :support-types="uploader.supportTypes"
                              :max-size="uploader.maxSize"
                              @handle-success="handleSuccess">
              <template #trigger="{disabled}">
                <el-button type="primary"
                           icon="el-icon-upload2"
                           :disabled="disabled">上传模板样例</el-button>
              </template>
            </FileLinkUploader>
          </div>
          <span class="tip">支持上传jpg/jpeg/png/doc/docx/pdf格式</span>
        </div>
        <div class="file-list" v-if="previewUrl">
          <div class="file-name">模板样例：</div>
          <div class="preview">
            <FilePreview :previewUrl="previewUrl"></FilePreview>
          </div>
        </div>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import FilePreview from '../../../../../../../widgets/custom/FilePreview'
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
import FileLinkUploader from '../../../../../../../widgets/custom/wrapper/FileLinkUploader'
export default {
  name: 'ThesisPracticePopperSampleTemplate',
  components: {
    FilePreview,
    DataGridDialog,
    FileLinkUploader
  },
  props: {
    templateFile: {
      type: String
    },
    templatePreview: {
      type: String
    },
    paperBatchId: {
      type: String,
      required: true
    },
    typeCode: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      uploader: {
        uploadUrl: '/workspace/manager/paper/batch/uploadSyllabusTemplate',
        supportTypes: ['.jpg', '.jpeg', '.png', '.doc', '.docx', '.pdf'],
        maxSize: 100 * 1024 * 1024
      },
      templateUrl: '',
      previewUrl: ''
    }
  },
  computed: {
    uploadParams () {
      return {
        paperBatchId: this.paperBatchId,
        type: this.typeCode
      }
    },
    curTemplateInfo () {
      switch (this.typeCode) {
        case 'preRejoin':
          return {
            name: '预答辩登记表',
            resultKey: 'preRejoinTemplate'
          }
        case 'apply':
          return {
            name: '毕业论文申请书',
            resultKey: 'applyTemplate'
          }
        case 'syllabus':
          return {
            name: '开题报告',
            resultKey: 'syllabusTemplate'
          }
      }
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleSuccess ({[this.curTemplateInfo.resultKey]: result}) {
      if (result) {
        this.previewUrl = result.previewUrl
        this.templateUrl = result.sourceUrl
      }
    },
    initData () {
      this.templateUrl = this.templateFile
      this.previewUrl = this.templatePreview
    }
  },
  watch: {
    visible: {
      handler (val) {
        if (!val) {
          this.templateUrl = ''
          this.FilePreview = ''
        }
      }
    },
    templateUrl (newVal) {
      if (newVal) {
        this.$emit('update:templateFile', newVal)
      }
    }
  }
}
</script>

<style lang="scss">
.thesis-practice-popper-sample-template{
  display: inline-block;
  & + .thesis-practice-popper-sample-template{
    margin-left: 10px;
  }
}
.thesis-practice-popper-sample-template-dialog{
  .sample-template-main{
    padding: 20px;
    & > .upload-template-wrap{
      padding-bottom: 15px;
      & > .upload-template{
        width: 150px;
        margin-bottom: 10px;
        .file-uploader-wrap{
          .el-upload{
            .el-button {
              i {
                margin-left: -10px;
              }
            }
          }
        }
      }
      & > .tip{
        font-size: 12px;
      }
    }
    & > .file-list{
      display: flex;
      align-items: center;
      padding-top: 15px;
      font-size: 12px;
      border-top: 1px solid #dde5eb;
    }
  }
}
</style>
